import React from "react";

export default function Map() {
  return (
    <section className="map">
      <div className="map__contacts">
        <h2 className="map__header">КОНТАКТЫ</h2>
        <a href="tel:+73432189586" className="map__text map__text-link">
          +7 (343) 218-95-86
        </a>
        <a
          href="mailto:urniidvi-public@mis66.ru"
          className="map__text map__text-link"
        >
          urniidvi-public@mis66.ru
        </a>
        <p className="map__text">г.Екатеринбург, ул.Щербакова, 8</p>

        <section className="map__timetable">
          <p className="map__text">Пн-Пт - 09:00-18:00</p>
          <p className="map__text">Сб - 09:00-14:00</p>
        </section>
      </div>
      <div className="map__address">
        <iframe
          title="Карта расположения института"
          src="https://yandex.ru/map-widget/v1/?ll=60.650520%2C56.786833&mode=poi&poi%5Bpoint%5D=60.650381%2C56.787002&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D1368945426&z=17"
          className="map__ya"
        ></iframe>
      </div>
    </section>
  );
}
